import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { FaTag, FaUser, FaRegBuilding, FaPhone } from "react-icons/fa";
import { useSelector } from "react-redux";
import Spinner from "../Spinner/Spinner";
import LogoImage from "../../assets/images/logo.png";
import BaseModal from "../../Base/BaseModal/BaseModal";
import OrderDetailModalItem from "../OrderDetailModalItem/OrderDetailModalItem";
import LittleMapModal from "../LittleMapModal/LittleMapModal";
import { Config } from "../../Config";
import { toast } from "react-toastify";
import ShowMap from "../ShowMap/ShowMap";

const SupplierContent = () => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showMapModal, setShowMapModal] = useState(false);
  const [defaultMap, setDefaultMap] = useState([]);
  const [provinces, setProvinces] = useState(null);
  const [cities, setCities] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [fullName, setFullName] = useState(null);
  const [company, setCompany] = useState(null);
  const [mobileNumber, setMobileNumber] = useState(null);
  const [telNumber, setTelNumber] = useState(null);
  const [showDocument, setShowDocument] = useState(false);
  const [city, setCity] = useState(null);
  const [address, setAddress] = useState(null);
  const [location, setLocation] = useState([]);
  const [sendDocumentShowSpinner, setSendDocumentShowSpinner] = useState(false);
  const [sendDocuments, setSendDocuments] = useState([]);
  const params = useParams();
  // ---------------------------------------------------------------------------------------------------
  useEffect(async () => {
    setMobileNumber(params.phoneNumber);
    await getDocuments();
    await getProvinces();
  }, []);

  const getProvinces = async () => {
    let requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    await fetch(`${Config.apiPath2}/providerApi/getProvinces`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setProvinces(result);
      })
      .catch((error) => console.log("error", error));
  };

  const getDocuments = async () => {
    let requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    await fetch(`${Config.apiPath2}/providerApi/getProviderDocumentTypes`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        try {
          setDocuments(result);
        } catch (err) {
          console.log(err);
        }
      })
      .catch((error) => console.log("error", error));
  };

  // ---------------------------------------------------------------------------------------------------
  const closeModalHandler = () => {
    setShowModal(false);
    let body = document.body;
    body.style.overflowY = "auto";
  };
  const closeModal = () => {
    setShowMapModal(false);
    let body = document.body;
    body.style.overflowY = "auto";
  };
  const showModalHandler = (type) => {
    if (type === "document") {
      setShowModal(true);
    } else if (type === "map") {
      setShowMapModal(true);
    }
  };
  const submitMapHandler = (map) => {
    setLocation(map);
    setDefaultMap(map);
    closeModal();
  };
  // ---------------------------------------------------------------------------------------------------
  const getCityHandler = (id) => {
    let requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(`${Config.apiPath2}/providerApi/getCities?provinceId=${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => setCities(result))
      .catch((error) => console.log("error", error));
  };
  // ---------------------------------------------------------------------------------------------------
  const submitHandler = async () => {
    if (!city) {
      toast.error("شهر خود را وارد کنید");
      return;
    } else if (!fullName) {
      toast.error("نام و نام خانوادگی وارد کنید");
      return;
    } else if (!telNumber) {
      toast.error("شماره تلفن ثابت وارد کنید");
      return;
    } else if (!company) {
      toast.error("نام مرکز را وارد کنید");
      return;
    } else if (location.length <= 0) {
      toast.error("موقعیت مکانی انتخاب کنید");
      return;
    } else if (!address) {
      toast.error("آدرس خود را وارد نمایید");
      return;
    }
    setShowSpinner(true);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = {
      cityId: city,
      fullName: fullName,
      phoneNumber: mobileNumber,
      telephone: telNumber,
      supplyCenterName: company,
      lat: location[0]?.toString() ?? "",
      long: location[1]?.toString() ?? "",
      address: address,
    };
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(raw),
      redirect: "follow",
    };
    await fetch(`${Config.apiPath2}/providerApi/register`, requestOptions).then(async (response) => {
      if (response.status == 200) {
        toast.success("اطلاعات شما ثبت شد. لطفا مدارک خود را ارسال کنید");
        setShowDocument(true);
        showModalHandler("document");
      } else {
        let resJson = await response.json();
        let err = Object.values(resJson.errors);
        err.forEach((i) => toast.error(i[0]));
      }
    });

    setShowSpinner(false);
  };
  const addToArrayHandler = (file, fileId) => {
    let prev = sendDocuments.filter((i) => i.ProviderDocumentTypeId !== fileId);
    setSendDocuments([...prev, { ProviderDocumentTypeId: fileId, Base64string: file }]);
  };
  const sendDocumentsHandler = async () => {
    setSendDocumentShowSpinner(true);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = {
      phoneNumber: mobileNumber,
      documents: sendDocuments,
    };
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(raw),
      redirect: "follow",
    };
    await fetch(`${Config.apiPath2}/ProviderApi/UploadDocument`, requestOptions).then((response) => {
      if (response.status == 200) {
        toast.success("مدارک با موفقیت ارسال شد");
        closeModalHandler();
        window.location.replace("https://panel.sadrayar.ir");
      } else {
        let resJson = response.text();
      }
    });

    setSendDocumentShowSpinner(false);
  };
  return (
    <div className="rightSide">
      {showModal && (
        <BaseModal title="بارگذاری مدارک" close={() => closeModalHandler()}>
          <div className="documentsWrapper">
            {documents?.map((item) => {
              return <OrderDetailModalItem key={item.id} doc={item} addToArray={addToArrayHandler} />;
            })}
            <button
              className={`btnLogin ${sendDocuments.length != documents.length && "invalidInput"}`}
              onClick={() => sendDocumentsHandler()}
            >
              {sendDocumentShowSpinner ? <Spinner color="#fff" /> : "ارسال"}
            </button>
          </div>
        </BaseModal>
      )}
      {showMapModal && (
        <LittleMapModal
          title="انتخاب موقعیت مکانی"
          defaultCenter={defaultMap.length > 0 ? defaultMap : [35.73853, 51.4326]}
          showSpinner={showSpinner}
          submitMapHandler={submitMapHandler}
          closeModal={closeModal}
          onlyAddress={true}
        />
      )}
      <div className="logo">
        <Link to="/">
          <img src={LogoImage} alt="logo" />
        </Link>
        <p className="pageTitle">ثبت نام به عنوان نماینده</p>
      </div>
      <div className="formWrapper">
        <div className="formGroup">
          <div className="caption">
            <input
              type="text"
              placeholder=""
              onChange={(e) => setFullName(e.target.value.replace(/\s\s+/g, " "))}
              value={fullName}
            />
            <span className="placeholder">نام و نام خانوادگی</span>
            <FaUser className="loginInputIcon" />
          </div>
        </div>
        <div className="formGroup">
          <div className="caption">
            <input
              type="text"
              placeholder=""
              onChange={(e) => setCompany(e.target.value.replace(/\s\s+/g, " "))}
              value={company}
            />
            <span className="placeholder">نام مرکز</span>
            <FaRegBuilding className="loginInputIcon" />
          </div>
        </div>
        <div className="formGroup">
          <div className="caption disableInput">
            <input type="text" placeholder="" defaultValue={mobileNumber} value={mobileNumber} />
            <span className="placeholder">شماره تلفن همراه</span>
            <FaPhone className="loginInputIcon" />
          </div>
        </div>
        <div className="formGroup">
          <div className="caption">
            <input
              type="text"
              placeholder=""
              onChange={(e) => setTelNumber(e.target.value.replaceAll(" ", ""))}
              value={telNumber}
            />
            <span className="placeholder">شماره تلفن ثابت</span>
            <FaPhone className="loginInputIcon" />
          </div>
        </div>
        <div className="formGroup">
          <div className="caption">
            <select onChange={(e) => getCityHandler(e.target.value)}>
              <option value="" disabled selected>
                استان
              </option>
              {provinces ? (
                provinces.map((item) => {
                  return (
                    <option key={item.id} value={item.id} onClick={() => getCityHandler(item.id)}>
                      {item.title}
                    </option>
                  );
                })
              ) : (
                <option disabled>لطفا صبر کنید</option>
              )}
            </select>
          </div>
        </div>
        <div className="formGroup">
          <div className="caption">
            <select onChange={(e) => setCity(e.target.value)}>
              <option value="" disabled selected>
                شهر
              </option>
              {cities ? (
                cities.map((item) => {
                  return (
                    <option key={item.id} value={item.id} onClick={() => setCity(item.id)}>
                      {item.title}
                    </option>
                  );
                })
              ) : (
                <option disabled>لطفا ابتدا استان را انتخاب کنید</option>
              )}
            </select>
          </div>
        </div>
        <div className="formGroup">
          <div className="caption">
            <textarea type="text" placeholder="" onChange={(e) => setAddress(e.target.value)} value={address} />
            <span className="placeholder">آدرس</span>
            <FaTag className="loginInputIcon" />
          </div>
        </div>
        {defaultMap.length > 0 && (
          <div className="formGroup">
            <div className="caption">
              <ShowMap
                height={200}
                defaultCenter={[defaultMap[0], defaultMap[1]]}
                anchor={[defaultMap[0], defaultMap[1]]}
              />
            </div>
          </div>
        )}
        <div className="formGroup">
          <button className="btnLogin modalBtn" onClick={() => showModalHandler("map")}>
            {defaultMap.length > 0 ? "تغییر آدرس" : "انتخاب آدرس"}
          </button>
        </div>
        {mobileNumber && showDocument && (
          <div className="formGroup">
            <button
              className={`btnLogin modalBtn ${documents.length <= 0 && "invalidInput"}`}
              onClick={() => showModalHandler("document")}
            >
              {documents.length > 0 ? "بارگذاری مدارک" : "درحال دریافت مدارک"}
            </button>
          </div>
        )}
        {mobileNumber && (
          <div className="formGroup">
            <button className="btnLogin" onClick={() => submitHandler()}>
              {showSpinner ? <Spinner color="#fff" /> : "ارسال"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(SupplierContent);
